/**
 * Created by mac on 3/2/21
 */

const MenuControlButton = {
    name: "MenuControlButton",
    buttonType: "control_button",
    icon: bundles.controlbuttons.frames.menu_icon_png,

    onClicked: function () {
        cleverapps.effects.fire("ui.menu.click");
        cleverapps.focusManager.display({
            focus: "SettingsWindowFromMenu",
            action: function (f) {
                new SettingsWindow();
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
    },

    isAvailableOnScene: function () {
        if (cleverapps.config.type === "battlefield" && Game.currentGame && Game.currentGame.mode === Epicart.MODE_BATTLE) {
            return false;
        }

        if (cleverapps.environment.hasScene([cleverapps.Environment.SCENE_EDITOR, cleverapps.Environment.SCENE_CHAT, cleverapps.Environment.SCENE_MINE])) {
            return false;
        }

        return cleverapps.user.checkAvailable(cleverapps.config.availables.MENU_CONTROL_BUTTON);
    },

    onUpdateAttention: function () {},

    updateAttention: function () {
        const hasPromo = cleverapps.crossPromo && cleverapps.crossPromo.havePromotion() && cleverapps.crossPromo.hasMark();
        const hasUnread = cleverapps.chat.hasUnread && (["merge", "merge2"].includes(cleverapps.config.type) || !Game.currentGame);

        this.onUpdateAttention(hasPromo || hasUnread);
    }
};
